module.exports = __webpack_public_path__ + "static/media/Workday_Step1b_Image4zx.14586ce4.jpg";